var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15548 14.6406C3.69798 14.6406 3.27048 14.4831 2.96298 14.1906C2.57298 13.8231 2.38548 13.2681 2.45298 12.6681L2.73048 10.2381C2.78298 9.78065 3.06048 9.17315 3.38298 8.84315L9.54048 2.32565C11.078 0.698147 12.683 0.653147 14.3105 2.19065C15.938 3.72815 15.983 5.33315 14.4455 6.96065L8.28798 13.4781C7.97298 13.8156 7.38798 14.1306 6.93048 14.2056L4.51548 14.6181C4.38798 14.6256 4.27548 14.6406 4.15548 14.6406ZM11.948 2.18315C11.3705 2.18315 10.868 2.54315 10.358 3.08315L4.20048 9.60815C4.05048 9.76565 3.87798 10.1406 3.84798 10.3581L3.57048 12.7881C3.54048 13.0356 3.60048 13.2381 3.73548 13.3656C3.87048 13.4931 4.07298 13.5381 4.32048 13.5006L6.73548 13.0881C6.95298 13.0506 7.31298 12.8556 7.46298 12.6981L13.6205 6.18065C14.5505 5.19065 14.888 4.27565 13.5305 3.00065C12.9305 2.42315 12.413 2.18315 11.948 2.18315Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0044 8.21263C12.9894 8.21263 12.9669 8.21263 12.9519 8.21263C10.6119 7.98013 8.72935 6.20263 8.36935 3.87763C8.32435 3.57013 8.53435 3.28513 8.84185 3.23263C9.14935 3.18763 9.43435 3.39763 9.48685 3.70513C9.77185 5.52013 11.2419 6.91513 13.0719 7.09513C13.3794 7.12513 13.6044 7.40263 13.5744 7.71013C13.5369 7.99513 13.2894 8.21263 13.0044 8.21263Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.0625H2.25C1.9425 17.0625 1.6875 16.8075 1.6875 16.5C1.6875 16.1925 1.9425 15.9375 2.25 15.9375H15.75C16.0575 15.9375 16.3125 16.1925 16.3125 16.5C16.3125 16.8075 16.0575 17.0625 15.75 17.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.f9f7f52c028f93f3615cd862dc9a9d49.svg";
export { ForwardRef as ReactComponent };